// the quiet words the intake's sheets name the parts of a person with (shared by MovedIn and Review)

/** how the person's facts are named here (a dimension's word, quietly) */
export const PART_WORDS: Record<string, string> = {
  preferences: "what you like",
  behavior: "how you work",
  tools: "your tools",
  voice: "how you talk",
  relationships: "the people in your life",
  habits: "your habits",
  interests: "your interests",
  hobbies: "your hobbies",
  somatic: "your body",
  use_times: "when you work",
  identity: "who you are",
  state: "what is on your mind",
  aversions: "what drains you",
  lexicon: "your words",
};
